import { useAuthStore } from "../store/auth.store";

const HeaderBar = () => {
  const user = useAuthStore((state) => state.user);

  return (
    <header className="h-14 bg-slate-900/60 border-b border-white/10 flex items-center justify-end px-6">
      <div className="text-sm text-slate-300">{user?.email || "—"}</div>
    </header>
    // <header className="h-14 bg-slate-900/60 border-b border-white/10 flex items-center justify-between px-6">
    //   <div className="flex items-center gap-2">
    //     <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-amber-500/10 border border-amber-500/20 text-amber-400 text-xs font-medium">
    //       <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
    //       Test Environment
    //     </span>
    //   </div>
    //   <div className="text-sm text-slate-300">{user?.email || "—"}</div>
    // </header>
  );
};

export default HeaderBar;
